export enum Actions {
  GET_DRAFTS_PENDING = 'GET_DRAFTS_PENDING',
  GET_DRAFTS_SUCCESS = 'GET_DRAFTS_SUCCESS',
  GET_DRAFTS_ERROR = 'GET_DRAFTS_ERROR',
  CONFIRM_DRAFT_PENDING = 'CONFIRM_DRAFT_PENDING',
  CONFIRM_DRAFT_SUCCESS = 'CONFIRM_DRAFT_SUCCESS',
  CONFIRM_DRAFT_ERROR = 'CONFIRM_DRAFT_ERROR',
}
